import React from 'react';
import * as prismicH from '@prismicio/helpers';
import { RichText } from '../../components/RichText';
import { BaseSlice } from '../../components/BaseSlice';
import { Bounded } from '../../components/Bounded';
import PrismicLink from '../../components/PrismicLink';
import clsx from 'clsx';

/**
 * @typedef {import("@prismicio/client").Content.PageIntroSlice} PageIntroSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<PageIntroSlice>} PageIntroProps
 * @param { PageIntroProps }
 */
const PageIntro = ({ slice, index, context }) => (
  <Bounded as="section" index={index} className={clsx('bounded', context.uid)}>
    <BaseSlice
      className={clsx('row slice', context.uid, slice.primary.css_class)}>
      <div className="col-lg-10">
        <RichText
          field={slice.primary.text}
          large={slice.variation === 'large'}
        />

        {prismicH.isFilled.link(slice.primary.buttonLink) && (
          <PrismicLink
            className="btn btn-primary"
            field={slice.primary.buttonLink}>
            {slice.primary.buttonText}
          </PrismicLink>
        )}
      </div>
    </BaseSlice>
  </Bounded>
);

export default PageIntro;
